<template>
  <BaseCard v-bind="style"
            v-on="$listeners">
    <slot />
  </BaseCard>
</template>

<script>
  import BaseCard from '@base/base-card'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CardSecondary',
    components: {
      BaseCard,
    },
    data: function () {
      return {
        style: {
          borderRadius: '8px',
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        backgroundColor: this.color.light1(),
        border: 'none',
        borderWidth: 'none',
        boxShadow: `0 4px 16px ${this.color.shadow2(0.2)}`,
        color: this.color.dark2(),
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
